"use strict";

module.exports = function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, elem, attrs, ctrl){
      var max = parseInt(scope.$eval(attrs.editorMaxlength));
      if (isNaN(max)){
        throw new Error('Max text must be an integer');
      }
      attrs.$observe('editorMaxlength', function(value){
        max = parseInt(value);
        if (isNaN(max)){
          throw new Error('Max text must be an integer');
        }
        if (ctrl.$dirty){
          ctrl.$validate();
        }
      });
      ctrl.$validators.maxlength = function(viewValue){
        return viewValue ? viewValue.length <= max : true;
      };
    }
  };
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/editor-maxlength.js